var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGuide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.5832V5.4165C2.5 5.07275 2.6224 4.77848 2.86719 4.53369C3.11198 4.2889 3.40625 4.1665 3.75 4.1665H16.25C16.5938 4.1665 16.888 4.2889 17.1328 4.53369C17.3776 4.77848 17.5 5.07275 17.5 5.4165V14.5832C17.5 14.9269 17.3776 15.2212 17.1328 15.466C16.888 15.7108 16.5938 15.8332 16.25 15.8332H3.75C3.40625 15.8332 3.11198 15.7108 2.86719 15.466C2.6224 15.2212 2.5 14.9269 2.5 14.5832ZM3.75 7.64567H5.95833V5.4165H3.75V7.64567ZM7.20833 7.64567H16.25V5.4165H7.20833V7.64567ZM7.20833 11.104H16.25V8.89567H7.20833V11.104ZM7.20833 14.5832H16.25V12.354H7.20833V14.5832ZM3.75 14.5832H5.95833V12.354H3.75V14.5832ZM3.75 11.104H5.95833V8.89567H3.75V11.104Z",
    fill: "#66D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGuide);
export default __webpack_public_path__ + "static/media/user-guide.2da7b12494c7fd1a45a33f7f6d4fd1e2.svg";
export { ForwardRef as ReactComponent };